import React from 'react'
import type { ComposeComponentHorizontalImageCtaFragment } from '../../../.graphql/generated-types'
import { ContentfulImageWithPlaceholder } from '../ContentfulImageWithPlaceholder'

export interface HorizontalImageCTAProps {
  data: ComposeComponentHorizontalImageCtaFragment
}

export function HorizontalImageCTA({ data }: HorizontalImageCTAProps) {
  if (data.url && data.image?.imageAsset && data.largeImage?.imageAsset) {
    const { imageAsset: smallImage, altText: smallImageAltText } = data.image
    const { imageAsset: largeImage, altText: largeImageAltText } =
      data.largeImage
    if (
      !smallImage.url ||
      !smallImage.height ||
      !smallImage.width ||
      !largeImage.url ||
      !largeImage.height ||
      !largeImage.width
    )
      return null
    return (
      <a href={data.url}>
        <div className="md:hidden">
          <ContentfulImageWithPlaceholder
            width={smallImage.width}
            height={smallImage.height}
            src={smallImage.url}
            alt={smallImageAltText ?? ''}
          />
        </div>
        <div className="hidden md:block">
          <ContentfulImageWithPlaceholder
            width={largeImage.width}
            height={largeImage.height}
            src={largeImage.url}
            alt={largeImageAltText ?? ''}
          />
        </div>
      </a>
    )
  }
  return null
}
